import React from 'react';
import { IconProps } from './types';

const Airports = (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.5 19.5" {...props}>
        <path
            fill="currentColor"
            d="M12.19 19.5H7.31v-2.91a7.264 7.264 0 0 1-4.4-4.4H0V7.31h2.91a7.264 7.264 0 0 1 4.4-4.4V0h4.88v2.91c2.05.72 3.68 2.35 4.41 4.4h2.9v4.88h-2.9a7.23 7.23 0 0 1-4.41 4.4v2.91ZM8.81 18h1.88v-2.54l.56-.15a5.766 5.766 0 0 0 4.08-4.07l.15-.56h2.53V8.8h-2.53l-.15-.56a5.732 5.732 0 0 0-4.08-4.07l-.56-.15V1.5H8.81v2.54l-.56.15a5.77 5.77 0 0 0-4.07 4.07l-.15.56H1.5v1.88h2.54l.15.56a5.77 5.77 0 0 0 4.07 4.07l.56.15v2.54Zm.94-4.53c-2.05 0-3.72-1.67-3.72-3.72S7.7 6.03 9.75 6.03s3.73 1.67 3.73 3.72-1.67 3.72-3.73 3.72Zm0-5.94c-1.22 0-2.22 1-2.22 2.22s1 2.22 2.22 2.22 2.23-1 2.23-2.22-1-2.22-2.23-2.22Z"
        />
    </svg>
);

export default Airports;
